export default __webpack_public_path__ + "static/media/merz-reception-lobby-new.d37bcabc.jpg";